import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    dashboard: {},
    monthlyData: [],
    revenueData: [],
    rentalsByCategory: [],
  },
  reducers: {
    setDashboard: (state, action) => {
      state.dashboard = action.payload.stats;
      state.monthlyData = action.payload.monthlyData;
      state.revenueData = action.payload.revenueMonthlyData;
      state.rentalsByCategory = action.payload.rentalsByCategory;
    },
  },
});

export const { setDashboard } = dashboardSlice.actions;

export const getDashboardData = () => async (dispatch) => {
  try {
    const url = `${BASE_URL}/dashboard/v1`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    dispatch(setDashboard(data.data));
  } catch (error) {
    toast.error(error.response.data.message);
  }
};

export default dashboardSlice.reducer;
